import { render, staticRenderFns } from "./ThirPartPay.vue?vue&type=template&id=40848238&"
import script from "./ThirPartPay.vue?vue&type=script&lang=js&"
export * from "./ThirPartPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports